const UtilsMixin = {
  methods: {
    isEmpty(object) {
      return Object.keys(object).length > 0;
    }
  }
};

export default UtilsMixin;


// WEBPACK FOOTER //
// ./src/mixins/utils.js